module.exports = __webpack_public_path__ + "img/canada-cancer-male.80e86a99.png";